import { useState } from "react";
import { FileSpreadsheet, FileText } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import { exportExcel, exportPdf } from "../lib/export";

export const ExportDialog = ({ open, onOpenChange, state, stats, logs }) => {
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const invalid = from && to && from > to;
  const count = logs.filter((l) => (!from || l.date >= from) && (!to || l.date <= to)).length;

  const go = (fn, kind) => {
    try {
      fn(state, stats, logs, from, to);
      toast.success(`${kind} report downloaded`);
    } catch (e) {
      console.error(e);
      toast.error(`Failed to create ${kind} report`);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="export-dialog" className="border-[color:var(--border)] bg-[color:var(--surface)] sm:max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl">Export Report</DialogTitle>
          <DialogDescription>Includes KPIs, status per team, performance table, analyst conclusion and daily logs for the selected period.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-3">
          <div className="space-y-1.5">
            <Label className="label">From</Label>
            <Input data-testid="export-from-date" type="date" value={from} onChange={(e) => setFrom(e.target.value)} />
          </div>
          <div className="space-y-1.5">
            <Label className="label">To</Label>
            <Input data-testid="export-to-date" type="date" value={to} onChange={(e) => setTo(e.target.value)} />
          </div>
        </div>
        <p data-testid="export-log-count" className={`font-mono text-xs ${invalid ? "text-red-400" : "text-[color:var(--muted)]"}`}>
          {invalid ? "\"From\" date must be before \"To\" date" : `${count} daily log${count === 1 ? "" : "s"} in this period${!from && !to ? " (all dates)" : ""}`}
        </p>
        <div className="grid grid-cols-2 gap-3">
          <Button data-testid="export-excel-button" disabled={!!invalid} onClick={() => go(exportExcel, "Excel")} className="bg-emerald-600 text-white hover:bg-emerald-500">
            <FileSpreadsheet className="mr-2 h-4 w-4" /> Excel (.xlsx)
          </Button>
          <Button data-testid="export-pdf-button" disabled={!!invalid} onClick={() => go(exportPdf, "PDF")} className="bg-red-600 text-white hover:bg-red-500">
            <FileText className="mr-2 h-4 w-4" /> PDF
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};
